/* External */
import { makeFetchActionTypes } from "../../utils";

export const baseActionName = "allStations";
export const actionTypes = makeFetchActionTypes(baseActionName);

export const fetchAllStations = () => ({
  type: actionTypes.FETCH
});
